import { request } from "./Request";
import { routes } from "../constants/constant.route";

const { GET_ACTIVE_BY_APP_TYPE } = routes.TERMS_CONDITIONS;
const API_URL = process.env.VITE_APP_API_URL || process.env.REACT_APP_API_URL;

export default class TermsConditionsService {
  /**
   * Fetches the active terms and conditions for the current app.
   * Baadshah frontend sends app: baadshah via Request.js by default.
   */
  static getActiveByAppType() {
    return request("GET", `${API_URL}${GET_ACTIVE_BY_APP_TYPE}`, null, null, null);
  }
}
